import * as React from "react"
import { connect } from "react-redux"
import { Radio } from "antd"
import { setFilters } from "../../filters/actions"
import type { FiltersIdentifier, FiltersObject } from "../../filters/types"
import { getFilters } from "../../filters/selectors"
import { classNames } from "../../../utils/classNames"

type Props = {
    style?: Record<string, any>
    className?: string
    filters: FiltersObject
    identifier: FiltersIdentifier
    setFilters: (identifier: FiltersIdentifier, attributes: any) => void
}
const defaultStyles = {
    width: "100%",
}

export enum StatusFilterEnum {
    Active = "active",
    Inactive = "inactive",
    All = "all",
}

class StatusFilterComponent extends React.PureComponent<Props> {
    setStatusFilter = val => {
        this.props.setFilters(this.props.identifier, {
            status: val.target.value,
        })
    }

    render() {
        return (
            <div className={classNames("status-filter-component", this.props.className)}>
                <Radio.Group
                    value={this.props.filters.status ?? StatusFilterEnum.Active}
                    onChange={val => this.setStatusFilter(val)}
                    style={{ ...defaultStyles, ...this.props.style }}>
                    <Radio.Button value={StatusFilterEnum.Active}>Active</Radio.Button>
                    <Radio.Button id="statusFilterInactive" value={StatusFilterEnum.Inactive}>
                        Inactive
                    </Radio.Button>
                    <Radio.Button value={StatusFilterEnum.All}>All</Radio.Button>
                </Radio.Group>
                <style jsx={true} global={true}>
                    {`
                        .status-filter-component .ant-radio-button-wrapper-checked {
                            background-color: var(--primary-color);
                            color: #fff;
                        }
                        .status-filter-component .ant-radio-button-wrapper-checked:hover {
                            color: #fff;
                        }
                    `}
                </style>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    filters: getFilters(state, props.identifier),
})

const mapDispatchToProps = {
    setFilters: setFilters,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(StatusFilterComponent)
